module.exports = __webpack_public_path__ + "static/media/customer-retention.c23df0f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/services/customer-retention.svg
// module id = 1262
// module chunks = 0